/**
 * Created by adalto on 6/3/14.
 */

Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};

Greenmile.Task.RelatedInfo.Driver = {

    removeLinkedDriverFromList: function (el) {

        var lineItem = el.parentNode.parentNode.parentNode.parentNode;

        if (lineItem.className === 'controls') {
            lineItem = el.parentNode.parentNode;
        }

        var lineItemContainer = lineItem.parentNode;

        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedDriverFromData: function (el) {

        var node = el.parentNode.parentNode;
        var nodes = Monet.Session.Task.lastLinkForm.drivers.nodes;
        var ids = Monet.Session.Task.lastLinkForm.drivers.ids;
        var data = Monet.Session.Task.lastLinkForm.drivers.data;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {
            if (nodes[i].id === node.id) {
                index = i;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            Monet.Session.Task.newTask.drivers.splice(index, 1);
        }

    },

    createDriverIdNode: function (data) {

        var divContainer = document.createElement('div');
        var divTitle = document.createElement('div');
        var divDel = document.createElement('div');
        var divDestroy = document.createElement('div');
        var divClear = document.createElement('div');
        var inputStatus = document.createElement('input');
        var input = document.createElement('input');
        var inputLinked = document.createElement('input');
        var linkedTaskWhen = document.createElement('input');

        divContainer.id = "driver_" + data.user.id;
        divContainer.className = "item_lookuplist_driver_" + data.user.id;

        divTitle.className = "title_item_added";
        divTitle.innerHTML = data.user.key;

        divDel.className = "del_item_added";

        divDestroy.className = "table-action-destroylink";
        divDestroy.innerHTML = "&nbsp;";

        divDestroy.addEventListener('click', (function (scope, data) {

            return function (e) {

                e.preventDefault();

                const confirmDeleteDriver = () => {

                    App.Views.Task.showLoadingElement(this);

                    Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                        return function () {

                            App.Views.Task.hideLoad();

                            scope.removeLinkedDriverFromList(e.target);
                            scope.removeLinkedDriverFromData(e.target);
                            Greenmile.Task.RelatedInfo
                                .removeTitleContainerIfEmptyTo(
                                    Greenmile.Task.RelatedInfo.collections.DRIVERS
                                );

                        };
                    }(e)));

                };

                Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteDriver);

            };

        }(this, data)));

        linkedTaskWhen.type = 'hidden';
        linkedTaskWhen.id = 'taskLinkeds[' + data.user.id + '].when';
        linkedTaskWhen.name = 'taskLinkeds[' + data.user.id + '].when';
        linkedTaskWhen.className = "modelAttribute";
        linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

        input.type = 'hidden';
        input.name = 'taskLinkeds[' + data.user.id + '].user.id';
        input.id = 'taskLinkeds[' + data.user.id + '].user.id';
        input.className = 'modelAttribute';
        input.value = data.user.id;

        inputStatus.type = 'hidden';
        inputStatus.name = 'taskLinkeds[' + data.user.id + '].status';
        inputStatus.id = 'taskLinkeds[' + data.user.id + '].status';
        inputStatus.className = "modelAttribute";
        inputStatus.value = '';

        inputLinked.type = 'hidden';
        inputLinked.name = 'taskLinkeds[' + data.user.id + '].id';
        inputLinked.id = 'taskLinkeds[' + data.user.id + '].id';
        inputLinked.className = "modelAttribute";
        inputLinked.value = data.id || '';

        divDel.appendChild(divDestroy);

        divContainer.appendChild(divTitle);
        divContainer.appendChild(divDel);
        divContainer.appendChild(divClear);
        divContainer.appendChild(input);
        divContainer.appendChild(inputStatus);
        divContainer.appendChild(inputLinked);
        divContainer.appendChild(linkedTaskWhen);

        Monet.Session.Task.lastLinkForm.drivers.data.push(data);
        Monet.Session.Task.lastLinkForm.drivers.nodes.push(divContainer);
        Monet.Session.Task.lastLinkForm.drivers.ids.push(input);

    },

    createFullDriverInfo: function (data) {

        Monet.Session.Task.lastLinkForm.drivers.nodes = [];
        Monet.Session.Task.lastLinkForm.drivers.data = [];
        Monet.Session.Task.lastLinkForm.drivers.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('user')) {
                this.createDriverIdNode(data[i]);
            }

        }

    }

};